
const PROJ = 'Projects'
const FILE = 'Files'
const CATG = 'Categories'
const KEYW = 'Keywords'
const KEYC = 'KeywordCategories'

const ALL_OA = [
  PROJ,
  FILE,
  CATG,
  KEYW,
  KEYC
]

export {
  ALL_OA,
  PROJ,
  FILE,
  CATG,
  KEYW,
  KEYC
}
